import { render, staticRenderFns } from "./allDetail.vue?vue&type=template&id=031b62a3&scoped=true&"
import script from "./allDetail.vue?vue&type=script&lang=js&"
export * from "./allDetail.vue?vue&type=script&lang=js&"
import style0 from "./allDetail.vue?vue&type=style&index=0&id=031b62a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031b62a3",
  null
  
)

export default component.exports